import en from "./en";
import it from "./it";
import fr from "./fr";
import ro from "@i18n/public/ro";

export const publicResources = {
    en: { public: en },
    it: { public: it },
    fr: { public: fr },
    ro: { public: ro },
} as const;